export default __webpack_public_path__ + "static/media/CNo.89-5.1c4b8205.jpg";